export const wellKnownGroupPrefix = [
  'RG_AZ_PIM_',
  'RG_AZ_APP_',
  'RG_APP_',
  'RG_AZ_TT_',
  'RG_AZ_LOC_',
  'RG_VPN_',
  'SPO_LOCATION_',
];
